import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import theme from "../styles/theme";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import { clearSnackbarAction, snackbarSelector } from '../../adapters/redux'
import {
  faTimesCircle,
} from "@fortawesome/free-regular-svg-icons";
import {
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const IconContainer = styled.span`
  padding-right: .5rem;
`;
const IconButton = styled.button`
  background: none;
  border: none;
  color: white;
`;

export default function InfoSnackbar() {
  const dispatch = useDispatch();

  const snackbar = useSelector(snackbarSelector);

  function handleClose() {
    dispatch(clearSnackbarAction());
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right"
      }}
      open={snackbar?.infoSnackbarOpen}
      autoHideDuration={4000}
      onClose={handleClose}
      aria-describedby="client-snackbar"
    >
      <SnackbarContent
        message={
          <span id="client-snackbar">
            <IconContainer>
              <FontAwesomeIcon icon={faExclamationTriangle} />
            </IconContainer>
            {snackbar?.infoSnackbarMessage}
          </span>
        }
        action={
          <IconButton onClick={handleClose}><FontAwesomeIcon icon={faTimesCircle} /></IconButton>
        }
      />
    </Snackbar>
  );
}